/*  eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CatelogueItem.css';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import AudioContentModal from './Modals/AudioContentModal';

function AudioContent({ curriculum, setCurriculum, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CIT NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CIT_A1">
          <FontAwesomeIcon icon={faVolumeUp} />
        </div>
        <div className="CIT_A2">
          Audio
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <AudioContentModal />
      </Modal>
    </div>
  );
}

export default AudioContent;
/*  eslint-enable no-unused-vars */
